import React, {Component} from 'react';
import $ from 'jquery';
import Utils from '../utils';
import data from '../data/map-data';
import MapSettings from '../data/map-settings';
import Selector from './Selector';
// Vector Map
//Vector map JS relies on a global variable (jQuery).
//In ES6, all imports are hoisted to the top of the file
//so if we used `import` to import vectorMap, it would
//execute earlier than we have assigned the global
//variable. This is why we have to use CommonJS require()
//here since it doesn't have the hoisting behavior.
window.jQuery = $;
require('jvectormap/jquery-jvectormap.min'); // Always use min as includes JVM lib too

class Map extends Component{
    
    renderMap(){
        $.fn.vectorMap('addMap', 'uk_regions_merc', data);
        this.map = $("#map").vectorMap(MapSettings);
    }

    componentDidMount(){
        document.addEventListener('click-uk-map', this.onRegionChange.bind(this), true);
        $(document).ready(()=>{
            this.renderMap(); 
            var mapUk = $('.map-uk');
            mapUk.fadeIn(350);       

            const regions = Utils.arrayFromObjectsKey(data.paths, "name");
            const regionsSorted = Utils.sortAlphabetically(regions, 'region');

            //var availableRegions = [];

            var locations = $($('.team-member-data').find('[data-location]'));
            $(regionsSorted).each(function (i, region) {
                var isAvailable = false;
                locations.each(function () {
                    var currentLocation = $(this).data('location');
                    if (currentLocation == region) {
                        //availableRegions.push(region);
                        isAvailable = true;
                    }
                });
                if (!isAvailable) {
                    $(Object.keys(data.paths)).each(function (q, key) {
                        if (region == data.paths[key].name) {
                            $(mapUk.find('path[data-code="' + key + '"]')).addClass("unavailable");
                            $(mapUk.find('text[data-code="' + key + '"]')).addClass("unavailable");
                        }
                    });
                }
            });
        });
    }
    
    componentWillUnmount() {
        $('.map-uk').fadeOut(200);
        this.map.remove("#map") // Remove/destroy the map
        this.map = null;
        document.removeEventListener('click-uk-map', this.onRegionChange.bind(this), true);
        $(window).off("resize");

    }

    onRegionChange(e){
        if (e.type === 'click-uk-map') {
            var contentWrapper = $('.component-data-wrapper');
            var regionData = $('.team-member-data').find("[data-location='" + data.paths[e.detail.code].name + "']").html();
            var vector = $('.jvectormap-container');

             //update the main content with the data from the selected region
            contentWrapper.html(regionData);

            //amend the region selector with the selected value
            var regionSelector = $('select.region-selector');
            if (regionSelector.find('[value="' + data.paths[e.detail.code].name + '"]').length > 0) {
                regionSelector.val(data.paths[e.detail.code].name);
            }

            //set the selected location on the map to active
            if (!vector.find("[data-code='" + e.detail.code + "']").hasClass("unavailable")) {
                vector.find("path").removeClass("active");
                vector.find("[data-code='" + e.detail.code + "']").addClass("active");
            }
        }   

    }

    onCloseInnerPanel(){
       this.props.closeRegion(this.props.currentRegion);
       this.props.closeLocation(this.props.currentLocation);
    }

    render(){
        return(
            <div className="large-6 columns component-map-wrapper">
                <Selector {...this.props} />  
                
                <div className="component-map hide-only-mobile">
                    <div id="map" className="map map-uk"></div>
                </div>
        </div> 
        )
    }
}

export default Map; 


// WEBPACK FOOTER //
// ./src/js/components/Map.js